<template>
<div class="chapter">
<div class="inner_page">
<p><a id="prf"></a></p>
<div class="fmhT">
    PREFACE
  </div>
<div class="fmshT">
    A COUPLE OF NOTES
  </div>
<div class="fmtx1">
    For people looking for medical counsel: Although the information, ideas, and perspectives contained in this book are based on Ayurvedic, Traditional Chinese, or Western allopathic principles or studies, and even though—in the case of Ayurvedic or Traditional Chinese Medicine—such perspectives have been employed for thousands of years, no part of this book should be taken or construed as medical diagnosis or treatment. One significant component of Eastern medical philosophy is that each person has individual, unique needs, so no single recommendation, no matter how sound, is sound for every individual. For any medical condition or personal medical, herbal, dietary, or lifestyle advice, always consult with a qualified health-care practitioner.
  </div>
<div class="fmtx">
    I’m not just saying this for legal reasons. There is always more to medicine than any one practitioner can know, not to mention more to an individual’s health than an author can address without ever having even met that person. It is up to each of us to do our own search, find what works for us, and implement it. This book was born out of my own attempts to understand the sea of information available on women’s health. The conclusions I draw are not facts. They are educated opinions.
  </div>
<div class="fmtx">
    For numbers and statistic buffs and critics: The data in many of the studies in this book describe the increased risk for an entire population—not the increased risk for an individual woman. Taken as the latter, they would be scarier. Taken as the former, they are still compelling numbers.
  </div>
<div class="fmtx">
    For Western-trained physicians: In my travels in the world, I haven’t found any group who loves the perspective that this book presents more than you do. While Western medicine describes each individual hormone, Eastern medicine provides a context for understanding how they interact. This is heady, exciting stuff.
  </div>
<div class="fmtx">
    For everyone else: You don’t have to have any background in either Western or Eastern medicine to understand the concepts in this book. Simple concepts are powerful and simply lay the framework for understanding complicated material in an easy and even enjoyable way. Bon voyage.
  </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// clau_9780738214993_oeb_prf_r1.vue?4bf972a0